import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Output } from '@angular/core';
import { AgGridCommon } from 'ag-grid-community';

@Component({
    selector: 'liq-grid-state-filter',
    templateUrl: './gridState.component.html',
    styles: [`
        .reset-filters-row {
            color: red;
            font-size: 24px;
            display: flex;
            flex-direction: row;
            padding-bottom: 8px;
            align-items: center;
        }

        .reset-filters-row button {
            font-size: 10px;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridStateControlsComponent implements AfterViewInit {
    @Output() clearFilters = new EventEmitter<void>();

    gridState: AgGridCommon<any, GridStateControlsComponent>;
    showResetFilters = false;

    constructor(
        public elementRef: ElementRef<HTMLElement>,
        private cdRef: ChangeDetectorRef
    ) {}

    ngAfterViewInit(): void {
        this.gridState['filterChanged'].subscribe(() => {
            this.showResetFilters = this.isFilterSelected();
            this.cdRef.markForCheck();
        });

        this.showResetFilters = this.isFilterSelected();
        this.cdRef.detectChanges();
    }

    isFilterSelected(): boolean {
        if (this.gridState && this.gridState.api.isAnyFilterPresent()) return true;
        return false;
    }

    clearGridFilters(): void {
        this.gridState.api.setFilterModel({});
        this.gridState.api.applyColumnState({ defaultState: { sort: null } });
        this.clearFilters.emit();
    }
}
